import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const usePillBadgeStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXXS),
    height: '1.25rem',
    paddingLeft: '0.375rem',
    paddingRight: '0.375rem',
    ...shorthands.borderRadius('9999px'),
    backgroundColor: tokens.colorBrandBackground2,
    fontSize: fontScale.caption,
    fontWeight: 400,
    lineHeight: '1.4em',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },

  available: {
    color: tokens.colorBrandForeground1,
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke1),
  },

  unavailable: {
    color: tokens.colorNeutralForegroundDisabled,
    ...shorthands.border('1px', 'solid', 'transparent'),
  },

  /**
   * Figma-aligned available pill (green tint). Opt-in: layout consumers add
   * `styles.figmaAvailable` instead of `styles.available`.
   */
  figmaAvailable: {
    backgroundColor: tokens.colorPaletteGreenBackground1,
    color: tokens.colorPaletteGreenForeground1,
    ...shorthands.border('1px', 'solid', 'transparent'),
  },

  /** Figma-aligned submitted/neutral pill. */
  figmaSubmitted: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
    ...shorthands.border('1px', 'solid', 'transparent'),
  },

  /** Figma recommended badge (warm tint) — used by SpaceCard overlay. */
  figmaRecommended: {
    backgroundColor: tokens.colorPaletteMarigoldBackground2,
    color: tokens.colorPaletteMarigoldForeground2,
    ...shorthands.border('1px', 'solid', 'transparent'),
    fontWeight: 600,
  },

  statusIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '0.75rem',
    height: '0.75rem',
  },
});
